import React from 'react';
import styles from './NewsItem.module.scss';
import likesIcon from '../../images/like.svg';
import likesIconWhite from '../../images/like-white.svg';
import disLikesIcon from '../../images/dislike.svg';

const NewsItem = ({ title, text, date, likes, dislikes, user }) => {
  return (
    <main className={styles.newsItemContainer}>
      <h1>{title}</h1>
      <p>{text}</p>
      <article className={styles.newsItemFooter}>
        <section className={likes}>
          <img className={styles.likeIcon} src={likesIcon} />
          <img className={styles.likeIconWhite} src={likesIconWhite} />
          <span>{likes}</span>
        </section>
        <section className={styles.profile}>
          <img className={styles.profileImg} src={user.img}></img>
          <span className={styles.profileTxt}>
            <div style={{ fontWeight: 600 }}>{user.name}</div>
            <div>{date}</div>
          </span>
        </section>
      </article>
    </main>
  );
};

export default NewsItem;
